import React from 'react';
import { Group } from 'src/design/atoms/Group';
import { MultiSelect } from 'src/design/atoms/MultiSelect';
import { ContactPicker } from 'src/app/selectors/ContactPicker';
import { IContact } from 'src/api/models/Organization';

export interface IWorkflowLogFilterFormProps {
  statusOptions: string[];
  statuses: string[];
  onStatusChange: (statuses: string[]) => void;
  customerNumber: string;
  contact: IContact | null;
  onContactChange: (contact: IContact | null) => void;
}

/** @registry Status MultiSelect + Submitted-To ContactPicker row for the Changes/Transmittals log-PDF modals. Empty selections mean no filter. */
export const WorkflowLogFilterForm: React.FC<IWorkflowLogFilterFormProps> = ({
  statusOptions,
  statuses,
  onStatusChange,
  customerNumber,
  contact,
  onContactChange,
}) => (
  <Group grow align="flex-start">
    <MultiSelect
      label="Status"
      placeholder="All statuses"
      data={statusOptions}
      value={statuses}
      onChange={onStatusChange}
      clearable
    />
    <ContactPicker
      label="Submitted To"
      customerNumber={customerNumber}
      initialValue={contact}
      onChange={onContactChange}
    />
  </Group>
);
